import React from "react"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { NoState } from "../models/interfaces"
import Ueberweisung from "../models/ueberweisung"
import { FeatureService } from "../services/FeatureService"
import { UeberweisungView } from "./UeberweisungView"

interface UeberweisungenViewProps {
    ueberweisung: Ueberweisung[]
    t?: any
}

export class UeberweisungenView extends React.Component<UeberweisungenViewProps, NoState> {
    onAddClicked = () => {
        EventBus.instance.emit("addUeberweisung")
    }

    render() {
        const { t } = this.props
        const disabled = FeatureService.isFeatureActive("DEMO")
        return (
            <Components.Collapsible title={t("rechnung.zahlungsdaten.ueberweisung.title")} collapsed={false}>
                {this.props.ueberweisung.map((u, idx) => (
                    <UeberweisungView key={idx} index={idx} ueberweisung={u} t={t} />
                ))}

                <Components.Row>
                    <Components.Col align={Components.Align.RIGHT}>
                        <Components.Button
                            id={"ueberweisung"}
                            style={Components.ButtonStyle.SECONDARY}
                            label={t("rechnung.zahlungsdaten.ueberweisung.hinzufuegen")}
                            onClick={this.onAddClicked}
                            disabled={disabled}
                            tooltip={disabled ? t("demoversion.nicht.aktiv.hinweis") : ""}
                            tooltipAtDisabled={disabled}
                        />
                    </Components.Col>
                </Components.Row>
            </Components.Collapsible>
        )
    }
}
